import React, { ComponentProps } from 'react'
import styled from 'styled-components'
import Image from 'components/Common/Image'

const TileImage = styled(Image)`
  grid-column: 1 / -1;
  grid-row: 1 / -1;
`

interface Props extends Pick<ComponentProps<typeof Image>, 'objectFit'> {
  image: App.Image;
}

function CartReviewTileImageContent(props: Props) {
  return <TileImage
    fit="center"
    width={190}
    dpr={2}
    {...props}
    role="presentation"
  />
}

export default CartReviewTileImageContent
